import { TextField } from "@material-ui/core";
import React from "react";
import { Controller } from "react-hook-form";

interface ITextValueInputProps {
  name: string;
  control: any;
  label: string;
  required: boolean;
  errorMsg: string;
  defaultValue: any;
}

export default ({
  name,
  control,
  label,
  required,
  errorMsg,
  defaultValue,
}: ITextValueInputProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          label={label}
          value={value}
          onChange={onChange}
          error={!!error}
          helperText={error ? error.message : null}
        />
      )}
      rules={required ? { required: errorMsg } : { required: false }}
    />
  );
};
